module.exports = __webpack_public_path__ + "img/icon-analysis.e96b4269.svg";